import type { Site } from '../Site';

export const ShootingUK: Site = {
  id: 'shootinguk',
  analyticsName: 'shootinguk',
  selector: '',
  logo: '',
  label: 'ShootingUK',
  platform: '',
};
